import React, { useState } from "react";
import { IoHome } from "react-icons/io5";

const HomePlayerSelect = ({ onBack, onComplete, onContinue }) => {
  const [selectedUsers, setSelectedUsers] = useState([]);

  const avatars = [
    { name: "Baron", img: "/images/avatar1.png" },
    { name: "Karen", img: "/images/avatar2.png" },
    { name: "Christopher", img: "/images/avatar3.png" },
    { name: "Konstantinos", img: "/images/avatar4.png" },
    { name: "Sharon", img: "/images/avatar5.png" },
  ];

  const toggleSelection = (name) => {
    setSelectedUsers((prev) =>
      prev.includes(name)
        ? prev.filter((user) => user !== name)
        : [...prev, name]
    );
  };

  return (
    <div className="bg-gradient-to-br from-custom-orange via-custom-pink to-custom-blue min-h-screen flex flex-col items-center">
      <div className="w-full flex justify-start pt-[38px] pr-[10px] pl-[26px]">
        <button
          onClick={onBack}
          className="bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
      </div>

      <main
        className="p-6 pt-12 pb-12 text-center w-11/12 max-w-md mt-[2rem]"
        style={{
          background: `url("/images/userWrapper.svg")`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "450px",
        }}
      >
        <h1 className="text-[40px] font-normal leading-[44px] mb-6 text-[#1E0A1E] font-young-serif">
          Who do we
          <br /> have today?
        </h1>
        <div className="flex flex-wrap justify-center gap-6">
          {avatars.map((user, index) => (
            <div
              key={user.name}
              className={`w-1/4 flex justify-center ${
                index >= 3 ? "mt-4" : ""
              }`}
            >
              <button
                onClick={() => toggleSelection(user.name)}
                className="flex flex-col text-[14px] font-normal font-space-grotesk items-center gap-2 transition"
              >
                <div
                  className={`w-20 h-20 rounded-full flex items-center justify-center overflow-hidden transition-all duration-200 ${
                    selectedUsers.includes(user.name)
                      ? "bg-[#FFE748]"
                      : "bg-[#EEEEEE]"
                  }`}
                >
                  <img
                    src={user.img}
                    alt={user.name}
                    className="object-cover w-full h-full p-2"
                  />
                </div>
                <span className="text-[#1E0A1E] text-[14px] font-normal font-space-grotesk">
                  {user.name}
                </span>
              </button>
            </div>
          ))}
        </div>
      </main>

      {selectedUsers.length >= 2 && (
        <div className="mt-6">
          <button
            onClick={onContinue}
            className="relative bg-black text-[40px] py-2 px-6 rounded-[30px] font-young-serif shadow-[2px_2px_4px_rgba(0,0,0,0.05),_15px_15px_2px_rgba(0,0,0,0.15)]"
          >
            <span className="bg-gradient-to-r from-[#FEA375] via-[#F6B3F6] to-[#4BAAF8] text-transparent bg-clip-text">
              Let’s gooo!
            </span>
          </button>
        </div>
      )}

      <footer className="w-full flex flex-col items-center mb-6 mt-auto">
        <div className="relative">
          <div className="bg-white rounded-full px-8 py-2 flex space-x-12 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
            <button className="flex flex-col items-center text-black relative">
              <IoHome className="text-2xl" />
              <span className="text-[10px] text-[#1E0A1E] mt-0.5 font-bold font-space-grotesk">
                Home
              </span>
            </button>
            <button
              onClick={onComplete}
              className="flex flex-col items-center text-gray-400"
            >
              <img
                src="/images/user-group.png"
                alt="Hub Icon"
                className="w-6 h-6"
              />
              <span className="text-[10px] mt-0.5 font-bold font-space-grotesk">
                Hub
              </span>
            </button>
          </div>
          <div className="absolute -bottom-4.5 left-1/2 transform -translate-x-1/2 w-32 h-1.5 bg-black rounded-full mt-3"></div>
        </div>
      </footer>
    </div>
  );
};

export default HomePlayerSelect;
